import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSoccer = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 30 30",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Soccer Ball" }), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.375 2.19686e-06C6.43592 2.19686e-06 1.31301e-05 6.43589 0 14.375C-1.19039e-05 22.3141 6.43587 28.75 14.375 28.75C22.314 28.75 28.75 22.3142 28.75 14.3751C28.75 6.43588 22.3141 -3.83173e-05 14.3749 2.19686e-06L14.375 2.19686e-06Z",
			fill: "none",
			fillRule: "evenodd",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.44375 12.1962L0 4.6575L6.39125 0L12.7825 4.6575L10.3425 12.1962L2.44375 12.1962L2.44375 12.1962Z",
			transform: "translate(8 8.252502)",
			fill: "none",
			fillRule: "evenodd",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.99 0L5.49375 2.3475L0 0",
			transform: "translate(8.897522 1.0950317)",
			fill: "none",
			fillRule: "evenodd",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.46875 0L4.00125 6.0275L0 10.6325",
			transform: "translate(0.049987793 4.9525146)",
			fill: "none",
			fillRule: "evenodd",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 0L5.92 1.36375L9.02875 6.565",
			transform: "translate(2.0812378 21.8125)",
			fill: "none",
			fillRule: "evenodd",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 6.55125L3.09875 1.3575L8.9925 0",
			transform: "translate(17.683777 21.816223)",
			fill: "none",
			fillRule: "evenodd",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.9725 10.5625L0 5.99L0.529999 0",
			transform: "translate(24.72998 4.986267)",
			fill: "none",
			fillRule: "evenodd",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 0L0 4.81",
			transform: "translate(14.391235 3.442505)",
			fill: "none",
			fillRule: "evenodd",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 1.93375L3.9475 0",
			transform: "translate(20.78247 10.976257)",
			fill: "none",
			fillRule: "evenodd",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 0L2.44 2.725",
			transform: "translate(18.34253 20.44873)",
			fill: "none",
			fillRule: "evenodd",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.4425 0L0 2.7275",
			transform: "translate(8.001221 20.44873)",
			fill: "none",
			fillRule: "evenodd",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 0L3.94875 1.93",
			transform: "translate(4.0512695 10.97998)",
			fill: "none",
			fillRule: "evenodd",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	] })]
});
export { SvgIconSoccer as ReactComponent };
